import React from 'react';
import PropTypes from 'prop-types';

import { FlagIcon } from 'components/Icons';

import './ProductReviewInappropriateFlag.scss';

const ProductReviewInappropriateFlag = ({ inappropriateFlagToggle, handleFlagClick }) => (
	<button
		type="button"
		className="productReviewInappropriateFlag"
		disabled={inappropriateFlagToggle}
		onClick={handleFlagClick}
		data-ugctest="flagreview"
	>
		{inappropriateFlagToggle ? (
			<div className="productReviewInappropriateFlag--flagged">
				<FlagIcon className="ProductReviewCard__icon" />
				Reported
			</div>
		) : (
			<>
				<FlagIcon className="ProductReviewCard__icon" />
				Report
			</>
		)}
	</button>
);

ProductReviewInappropriateFlag.defaultProps = {
	inappropriateFlagToggle: false
};
ProductReviewInappropriateFlag.propTypes = {
	inappropriateFlagToggle: PropTypes.bool,
	handleFlagClick: PropTypes.func.isRequired
};

export default ProductReviewInappropriateFlag;
